const scrollOffset = 400;
 
const scrollElement = document.querySelectorAll(".image-blur__scroll");
 
const elementInView = (el, offset = 0) => {
  const elementTop = el.getBoundingClientRect().top;
 
  return (
    elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - offset)
  );
};
 
const displayScrollElement = (index) => {
  scrollElement[index].classList.add('scrolled');
}
 
const hideScrollElement = (index) => {
  scrollElement[index].classList.remove('scrolled');
}
 
const handleScrollAnimation = () => {
    for(let i = 0; i < scrollElement.length; i++) {
        if (elementInView(scrollElement[i], scrollOffset)) {
            displayScrollElement(i);
        } else {
            hideScrollElement(i);
        }
    }
}
 
window.addEventListener('scroll', () => {
  handleScrollAnimation();
})